import { render, staticRenderFns } from "./BatchPopup.vue?vue&type=template&id=675ece14&scoped=true"
import script from "./BatchPopup.vue?vue&type=script&lang=js"
export * from "./BatchPopup.vue?vue&type=script&lang=js"
import style0 from "./BatchPopup.vue?vue&type=style&index=0&id=675ece14&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675ece14",
  null
  
)

export default component.exports